export const createFuzzyRegex = (searchTerm: string): RegExp => {
    if (!searchTerm) {
        return /.*/;
    }

    const pattern = searchTerm
        .split('')
        .map((c: string) => `${c}.*`)
        .join('')
        .slice(0, -2);

    return new RegExp(pattern, 'i');
};
